import { Component, Input } from '@angular/core';

@Component({
    selector: 'tvl-spinner-load',
    templateUrl: './spinner-load.component.html',
    styleUrls: ['./spinner-load.component.scss'],
    standalone: false
})
export class SpinnerLoadComponent {
  @Input()
  public isShow: boolean;

  @Input()
  public isFullPage: boolean = false;
}
